import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TextComponent} from './text.component';


@NgModule({
  imports: [
    ReactiveFormsModule,
    MatInputModule
  ],
  declarations: [
    TextComponent
  ],
  entryComponents: [
    TextComponent
  ],
  exports: [
    TextComponent
  ]
})

export class TextModule {}
